import { IMG } from "./assets";

// Card imagery for the occasions grid — text lives in data/translations.js (same order).
export const occasionImgs = [IMG.dinnerParty, IMG.canapes, IMG.tablescape, IMG.heroDining, IMG.grazing, IMG.corporate];

export const galleryImages = [
  { src: IMG.grazingBoard, alt: "Mediterranean grazing and charcuterie board" },
  { src: IMG.canapesSpread, alt: "Selection of canapés and bruschetta" },
  { src: IMG.prawnsPan, alt: "Garlic king prawns" },
  { src: IMG.grazingTableEvent, alt: "Grazing table at a private celebration" },
  { src: IMG.berryDessert, alt: "Plated berry dessert" },
  { src: IMG.paellaPan, alt: "Seafood paella in the pan" },
  { src: IMG.glazedDessert, alt: "Glazed berry dessert with caramel tuile" },
  { src: IMG.porkCarrot, alt: "Sliced pork with carrot purée" },
  { src: IMG.platedStarters, alt: "Plated starters ready for service" },
  { src: IMG.porchettaPlate, alt: "Rolled pork with crackling crumb and herb purée" },
];
